// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "AdviceSetCreateDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { QuestionResponseGenShape } from "./question-response.gen";

export const AdviceSetCreateDtoGenShape = z.strictObject({
  libraryId: z.string(),
  name: z.string(),
  description: z.string(),
  slug: z.string(),
  keywords: z.string(),
  tagId: z.string().nullable().default(null),
  alwaysInclude: z.boolean(),
  quickExit: z.boolean(),
  snippetIds: z.array(z.string()),
  relatedAdvice: z.array(QuestionResponseGenShape),
});
